import { staticMediaUrl } from '@/fo/util/image-loader';

import { ArticleBanner } from './types';

export const mockBanners: ArticleBanner[] = [
  {
    id: '1',
    title: 'ТОП-5 средств для ухода за кожей с акне у подростков',
    tags: [
      {
        id: '1',
        title: 'Жирная кожа и несовершенства',
        color: '#00C389'
      }
    ],
    imageUrl: staticMediaUrl('banner/blog/1/banner.png'),
    mobileImageUrl: staticMediaUrl('banner/blog/1/banner.png'),
    imageAlt: 'ТОП-5 средств для ухода за кожей с акне у подростков',
    articleUrl: '/articles/1',
    withDoctor: true
  },
  {
    id: '2',
    title: 'Салициловая кислота: руководство по применению',
    tags: [
      {
        id: '2',
        title: 'Продление молодости',
        color: '#582C83'
      }
    ],
    imageUrl: staticMediaUrl('banner/blog/1/banner.png'),
    mobileImageUrl: staticMediaUrl('banner/blog/1/banner.png'),
    imageAlt: 'ТОП-5 средств для ухода за кожей с акне у подростков',
    articleUrl: '/articles/1'
  }
];
